import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import BeatLoader from 'react-spinners/BeatLoader';
import ArchiveModal from '../components/modals/archive';
import StatusModal from '../components/modals/status';
import AssignModal from '../components/modals/assign';
import IcoArrow from '../assets/ico-arrow';
import CustomLoader from '../components/custom-loader';
import { fetchOrders, updateStatus, selectAllOrders, resetStatus, resetOrders, updateAssignedUser, updateCaseManager } from '../reducers/orders-slice';
import FilterMethods from '../utility/filter-methods';
import { selectActiveFeatures, selectPortalUser } from '../reducers/auth-slice';
import { fetchNotifications, selectAllNotifications, resetNotificationStatus, resetNotifications } from '../reducers/notifications-slice';
import IcoMail from '../assets/ico-mail';
import ReassignCaseManagerModal from '../components/modals/reassign-case-manager';


const OrdersWithNotifications = () => {
    const [ordersLoaded, setOrdersLoaded] = useState(false);
    // eslint-disable-next-line
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedFirm, setSelectedFirm] = useState([]);
    const activeFeatures = useSelector(selectActiveFeatures);
    const portalUser = useSelector(selectPortalUser);
    const [showDropdown, setShowDropdown] = useState(false);
    const [clearRows, setClearRows] = useState(false);
    const [allowNewOrders, setAllowNewOrders] = useState(true);
    //setting visible orders for lazy loading
    // const [visibleOrders, setVisibleOrders] = useState(15);
    const dispatch = useDispatch();

    /**
     * get orders
     */
    const orders = useSelector(selectAllNotifications);
    const orderStatus = useSelector(state => state.notifications.status);

    //loads variable that contains session storage item activeFilters
    const loadedFilters = JSON.parse(window.sessionStorage.getItem('activeNotificationFilters'));

    // fetch orders details on each initial render
    useEffect(() => {

        if (orderStatus === 'idle' && !ordersLoaded) {
            dispatch(resetNotifications());
            dispatch(fetchNotifications());

        } else if (orderStatus === 'succeeded' && !ordersLoaded) {
            // anything that needs to happen AFTER 
            // the data has loaded (e.g. removing loading indicator)
            setOrdersLoaded(true);
        }
    }, [setOrdersLoaded, ordersLoaded, dispatch, orderStatus]);

    // set when order details have been loaded
    useEffect(() => {
        if (ordersLoaded) {
            dispatch(resetNotificationStatus());
        }
    }, [dispatch, ordersLoaded]);

    useEffect(() => {
        setAllowNewOrders(portalUser && (portalUser.userType == 'glucroft' || (portalUser.organization && portalUser.organization.status == 'Enabled')))
    }, [portalUser]);

   //function to handle lazy loading of more orders
//      const loadMoreOrders = useCallback(() => {
//         if (visibleOrders < orders.length) {
//             setVisibleOrders(visibleOrders + 5); // Load 5 more orders
//         }
//     }, [visibleOrders, orders]);

// function to handle loading more orders once handleScroll breakpoint has been hit
//     const handleScroll = useCallback(() => {
//         const tableContainer = document.getElementById('table-container-notifications'); 
//         if (tableContainer) {
//           const tableHeight = tableContainer.clientHeight;
//           const tableContentHeight = tableContainer.scrollHeight;
      
//           if (tableContainer.scrollTop >= tableContentHeight - tableHeight - 25 && visibleOrders < orders.length) {
//             loadMoreOrders();
//           }
//         }
//       }, [loadMoreOrders, visibleOrders, orders]);

//setting an eventListener to be called when handleScroll breakpoint is detected
// useEffect(() => {
//     const tableContainer = document.getElementById('table-container-notifications');
//     if (tableContainer) {
//       tableContainer.addEventListener('scroll', handleScroll);
//     }

//     return () => {
//       if (tableContainer) {
//         tableContainer.removeEventListener('scroll', handleScroll);
//       }
//     };
//   }, [handleScroll]);

    /**
     * handle filters functionality
     */
    const [appliedFilters, setApplyFilters] = useState([]);
    const [filters, setFilters] = useState([]);
    const [displayedFilters, setDisplayedFilters] = useState("");

        //will populate the filters with the filters object in session storage if the object is not null, else it will set everything to empty
        useEffect(() => {
            if (loadedFilters != null && orderStatus === 'idle' && !ordersLoaded) {
                setFilters(loadedFilters);
                setDisplayedFilters(FilterMethods.concatFilters(loadedFilters));
                setApplyFilters(loadedFilters);
            }
        }, [loadedFilters, orderStatus, ordersLoaded])
    
        // if the toggle for show dropdown is true then it will load checked filters, breaking it out into a use effect fixed
        // issue of not loading on the first click since the function was running before the dropdown opened
        useEffect(() => {
            if (showDropdown && loadedFilters != null) {
                FilterMethods.applyLoadedFilters(loadedFilters);
            }
        }, [showDropdown, loadedFilters]);

    const handleApplyFilters = (e) => {
        e.preventDefault();
        setDisplayedFilters(FilterMethods.concatFilters(filters));
        setApplyFilters(filters);
        //sets session storage variable to active filters checked
        window.sessionStorage.setItem("activeNotificationFilters", JSON.stringify(filters));
        setShowDropdown(false);
        // setVisibleOrders(15);
    }

    const handleClearFilters = (e) => {
        e.preventDefault();
        FilterMethods.clearFilters();
        setFilters([]);
        setApplyFilters([]);
        setDisplayedFilters("");
        setShowDropdown(false);
        //sets session storage variable to null
        window.sessionStorage.setItem("activeNotificationFilters", null);
        // setVisibleOrders(15);
    };

    // fetch all orders again after update
    const fetchAllOrdersAfterDispatch = (dispatchFunction) => {
        dispatchFunction.then(() => {
            dispatch(resetNotifications());
            dispatch(fetchNotifications());
        })
        // setVisibleOrders(15);
    }

    /**
     * handle archive functionality
     */
    const [showArchiveModal, setShowArchiveModal] = useState(false);
    const handleCloseArchiveModal = () => {
        setShowArchiveModal(false);
    }
    const handleShowArchiveModal = () => setShowArchiveModal(true);

    const handleArchiveButton = (e) => {
        e.preventDefault();
        if (selectedRows.length > 0) {
            const dispatchFunc = dispatch(updateStatus({ orderIds: selectedRows, status: "Archived" }));
            fetchAllOrdersAfterDispatch(dispatchFunc);
        }
        handleCloseArchiveModal();
        setClearRows(!clearRows);
        setSelectedRows([]);
        // setVisibleOrders(15);
    };

    /**
     * handle status functionality
     */
    const [showStatusModal, setShowStatusModal] = useState(false);
    const handleCloseStatusModal = () => setShowStatusModal(false);
    const handleShowStatusModal = () => setShowStatusModal(true);

    // eslint-disable-next-line
    const [status, setStatus] = useState("");
    const handleStatusChange = (e) => {
        e.preventDefault();
        setStatus(e.target.value);

    };

    const handleStatusButton = (e) => {
        e.preventDefault();
        if (selectedRows.length > 0) {
            const dispatchFunc = dispatch(updateStatus({ orderIds: selectedRows, status }));
            fetchAllOrdersAfterDispatch(dispatchFunc);
        }
        handleCloseStatusModal();
    };


    /**
     * handle assign glucroft user functionality
     */
    const [showAssignModal, setShowAssignModal] = useState(false);
    const handleCloseAssignModal = () => setShowAssignModal(false);
    const handleShowAssignModal = () => setShowAssignModal(true);

    // eslint-disable-next-line
    const [user, setUser] = useState("");
    const handleUserChange = (e) => {
        e.preventDefault();
        setUser(e.target.value);
    };

    const handleAssignButton = (e) => {
        e.preventDefault();
        if (selectedRows.length > 0 && user != "Select a User") {
            const dispatchFunc = dispatch(updateAssignedUser({ orderIds: selectedRows, user }));
            fetchAllOrdersAfterDispatch(dispatchFunc);
        }
        handleCloseAssignModal();
    };

    /**
     * handle assign case Manager functionality
     */
    const [showReassignCaseManagerModal, setShowReassignCaseManagerModal] = useState(false);
    const handleCloseReassignCaseManagerModal = () => setShowReassignCaseManagerModal(false);
    const handleShowReassignCaseManagerModal = () => setShowReassignCaseManagerModal(true);
    const [caseManager, setCaseManager] = useState("");
    const handleReassignChange = (e) => {
           e.preventDefault();
           setCaseManager(e.target.value);
       };

    const handleReassignButton = (e) => {
        e.preventDefault();
        if (selectedRows.length > 0 && caseManager !== "Select a Case Manager") {
            const dispatchFunc = dispatch(updateCaseManager({ orderIds: selectedRows, caseManager }));      
            fetchAllOrdersAfterDispatch(dispatchFunc);
        }
        handleCloseReassignCaseManagerModal();
    };


    /**
     * handle changing of selected rows in the table
     */
    const handleSelectedRowsChange = ({ selectedRows }) => {

        //Store selected Order Ids in state
        if (selectedRows.length > 0) {
            var orderIds = [];
            selectedRows.forEach(x => {
                orderIds.push(x.id);
            })        
            setSelectedRows(orderIds);

            //also store the firm names to reduce orders query in reassign manager modal
            var firmNames = [];
            selectedRows.forEach(x => {
                firmNames.push(x.firm);
            })        
            setSelectedFirm(firmNames);
        } else {
            setClearRows(!clearRows);
            setSelectedRows([]);
            setSelectedFirm([]);
        }
    };

    


    /**
     * setup orders table
     */
    const nonCaseManagerColumns = [
        {
            name: 'Order',
            selector: row => row.orderNumber,
            cell: row => row.status === 'Draft' ? <Link to={`/intake/general-information?orderId=${row.id}`} key={row.id}>{row.orderNumber}</Link> : <Link to={`/orders/order-details/${row.id}`} key={row.id}>{row.orderNumber}</Link>,
            sortable: true,
        },
        {
            name: 'Law Firm',
            selector: row => row.firm,
            sortable: true,
        },
        {
            name: 'Case Manager',
            selector: row => row.assignedFirm,
            sortable: true,
        },
        {
            name: <span title="Case Name">Case Name</span>,
            selector: row => row.caseName,
            cell: row => <Link to={`/orders/case-details/${row.caseId}`} key={`caseName${row.id}`}>{row.caseName}</Link>,
            sortable: true,
        },
        {
            name: 'Investigation Type',
            selector: row => row.investigationType,
            sortable: true,
        },
        {
            name: 'Assigned (G.I.)',
            selector: row => row.assignedGI,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
        },
        {
            name: 'Submit Date',
            selector: row => row.start,
            cell: row => <span key={`startDate${row.id}`}>{new Date(row.start.endsWith('Z') ? row.start : row.start+"Z").toLocaleDateString()}</span>,
            sortable: true,
        },
        {
            name: 'Last Edit',
            selector: row => row.lastEdit,
            cell: row => <span key={`editDate${row.id}`}>{new Date(row.lastEdit.endsWith('Z') ? row.lastEdit : row.lastEdit+"Z").toLocaleDateString()}</span>,
            sortable: true,
        },
        {
            name: 'Notification',
            selector: row => row.attention,
            cell: row => ( row.attentionMessage != null && !activeFeatures.includes('f_InternalInvestigator_AssignRoles') && !activeFeatures.includes('f_FieldInvestigator_AssignRoles') ? <Link className='button note' to={`/orders/order-details/${row.id}#notifications`} title ={row.attentionMessage}><IcoMail /></Link> : null),
            sortable: true,
        },
    ];

    const caseManagerColumns = [
        {
            name: 'Order',
            selector: row => row.orderNumber,
            cell: row => row.status === 'Draft' ? <Link to={`/intake/general-information?orderId=${row.id}`} key={row.id}>{row.orderNumber}</Link> : <Link to={`/orders/order-details/${row.id}`} key={row.id}>{row.orderNumber}</Link>,
            sortable: true,
        },
        {
            name: 'Submit Date',
            selector: row => row.start,
            cell: row => <span key={`startDate${row.id}`}>{new Date(row.start.endsWith('Z') ? row.start : row.start+"Z").toLocaleDateString()}</span>,
            sortable: true,
        },
        {
            name: 'Case Manager',
            selector: row => row.assignedFirm,
            sortable: true,
        },
        {
            name: <span title="Case Name">Case Name</span>,
            selector: row => row.caseName,
            cell: row => activeFeatures.includes('f_fieldInvestigatorView')  ? row.caseName : <Link to={`/orders/case-details/${row.caseId}`} key={`caseName${row.id}`}>{row.caseName}</Link>,
            sortable: true,
        },
        {
            name: 'Investigation Type',
            selector: row => row.investigationType,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
        },
        {
            name: 'Notification',
            selector: row => row.attention,
            cell: row => ( row.attentionMessage != null && !activeFeatures.includes('f_InternalInvestigator_AssignRoles') && !activeFeatures.includes('f_FieldInvestigator_AssignRoles') ? <Link className='button note' to={`/orders/order-details/${row.id}#notifications`} title ={row.attentionMessage}><IcoMail /></Link> : null),
            sortable: true,
        },
    ];

    const columns = activeFeatures.includes('f_CaseManagerView') ? caseManagerColumns : nonCaseManagerColumns;

    const conditionalRowStyles = [
        {
            when: row => row.colorCode === 1,
            style: {
                //Red -> Aged Out
                backgroundColor: '#FFC5B4',
            },
        },
        {
            when: row => row.colorCode === 2,
            style: {
                //Yellow -> Waiting for Client
                backgroundColor: '#FCFAD5',
            },
        },
        {
            when: row => row.attention > 0 && !activeFeatures.includes('f_InternalInvestigator_AssignRoles') && !activeFeatures.includes('f_FieldInvestigator_AssignRoles'),
            style: {
                //If a row needs attention bold the font
                fontWeight: 600
            }
        }
    ];

    const paginationComponentOptions = {
        noRowsPerPage: true,
    };

    // declaring filterdData in a variable so a slice can be made of only the visible orders on screen but its still filtering all orders which are loaded initially
    const filteredData = FilterMethods.filteredData(orders, appliedFilters);

    //function showing order totals below table
    const orderTotal = () => {
        const orderCount = filteredData ? filteredData.length : orders.length;
  
        return (
            <p>{orderCount} orders</p>
        )
    }

    return (
        <div className="page">
            {(orderStatus === 'loading') &&
                <div className="loader-container">
                    <BeatLoader color="#00818C" />
                </div>
            }

            <div className="page-header page-header-sticky">
                <div className="page-header-title">
                    <h1>Orders With Notifications</h1>
                    <div className="page-header-title-filters">{displayedFilters}</div>
                </div>

                <div className="page-header-actions">
                    <Dropdown className="filter" align="end" show={showDropdown} onToggle={(isOpen) => setShowDropdown(isOpen)}>
                        <Dropdown.Toggle id="dropdown-filter" className="button primary filter">
                            Filter <IcoArrow />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Header className="center">
                                <button className="button primary" onClick={handleApplyFilters}>Apply</button>
                                <button className="button outlined primary" onClick={handleClearFilters}>Clear</button>
                            </Dropdown.Header>

                            <Accordion>
                                {!activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Law Firm</Accordion.Header>
                                        <Accordion.Body>
                                            {[...new Set(orders.map(order => order.firm))].map((firm, i) => (
                                                <Form.Check type={'checkbox'} name={`firm`} id={`lf${i}`} key={`lf${i}`}>
                                                    <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "firm", filters))} />
                                                    <Form.Check.Label id={`lf${i}-label`}>{firm}</Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Case Manager</Accordion.Header>
                                    <Accordion.Body>
                                        {[...new Set(orders.map(order => order.assignedFirm))].map((assignedFirm, i) => (
                                            <Form.Check type={'checkbox'} name={`assignedFirm`} id={`af${i}`} key={`af${i}`}>
                                                <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "assignedFirm", filters))} />
                                                <Form.Check.Label id={`af${i}-label`}>{assignedFirm}</Form.Check.Label>
                                            </Form.Check>
                                        ))}
                                    </Accordion.Body>
                                </Accordion.Item>
                                {!activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>Investigation Type</Accordion.Header>
                                        <Accordion.Body>
                                            {[...new Set(orders.map(order => order.investigationType))].map((investigationType, i) => (
                                                <Form.Check type={'checkbox'} name={`investigation-type`} id={`it${i}`} key={`it${i}`}>
                                                    <Form.Check.Input onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "investigationType", filters))} />
                                                    <Form.Check.Label id={`it${i}-label`}>{investigationType}</Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                {!activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>Assigned (G.I.)</Accordion.Header>
                                        <Accordion.Body>
                                            {[...new Set(orders.map(order => order.assignedGI))].map((assignedGI, i) => (
                                                <Form.Check type={'checkbox'} name={`assignedGI`} id={`agi${i}`} key={`agi${i}`}>
                                                    <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "assignedGI", filters))} />
                                                    <Form.Check.Label id={`agi${i}-label`}>{assignedGI}</Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                {!activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>Status</Accordion.Header>
                                        <Accordion.Body>
                                            {[...new Set(orders.map(order => order.status))].map((status, i) => (
                                                <Form.Check type={'checkbox'} name={`status`} id={`s${i}`} key={`s${i}`}>
                                                    <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "status", filters))} />
                                                    <Form.Check.Label id={`s${i}-label`}>{status}</Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                {!activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="5">
                                        <Accordion.Header>Aging Date</Accordion.Header>
                                        <Accordion.Body>
                                            <Form.Check type={'checkbox'} name={`agingDate`} id={`ad0`}>
                                                <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "colorCode", filters))} />
                                                <Form.Check.Label id={`ad0-label`}>Cleared</Form.Check.Label>
                                            </Form.Check>
                                            <Form.Check type={'checkbox'} name={`agingDate`} id={`ad1`}>
                                                <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "colorCode", filters))} />
                                                <Form.Check.Label id={`ad1-label`}>Aged Out</Form.Check.Label>
                                            </Form.Check>
                                            <Form.Check type={'checkbox'} name={`agingDate`} id={`ad2`}>
                                                <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "colorCode", filters))} />
                                                <Form.Check.Label id={`ad2-label`}>Waiting on Client</Form.Check.Label>
                                            </Form.Check>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                {activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="6">
                                        <Accordion.Header>Case Name</Accordion.Header>
                                        <Accordion.Body>
                                            {[...new Set(orders.map(order => order.caseName))].map((caseName, i) => (
                                                <Form.Check type={'checkbox'} name={`caseName`} id={`af${i}`} key={`af${i}`}>
                                                    <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "caseName", filters))} />
                                                    <Form.Check.Label id={`af${i}-label`}>{caseName}</Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                </Accordion>
                        </Dropdown.Menu>
                    </Dropdown>

                    {activeFeatures.some(x => ['f_Admin_Firm','f_Admin_CaseMgr','f_Admin_Users'].includes(x)) && <Dropdown className="new" align="end">
                        <Dropdown.Toggle id="dropdown-add" className="button secondary new">
                            + Add New
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            { activeFeatures.includes('f_Admin_Firm') && <Dropdown.Item href="/admin/law-firm">Law Firm</Dropdown.Item> }
                            { activeFeatures.includes('f_Admin_CaseMgr') && <Dropdown.Item href="/admin/case-manager">Case Manager</Dropdown.Item> }
                            { activeFeatures.includes('f_Admin_Users') && <Dropdown.Item href="/admin/glucroft-user">Glucroft User</Dropdown.Item> }
                        </Dropdown.Menu>
                    </Dropdown>}

                    <Dropdown className="action" align="end">
                        <Dropdown.Toggle id="dropdown-action" className="button tertiary action">
                            Choose an Actions <IcoArrow />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            { activeFeatures.includes('f_Archive') && <Dropdown.Item onClick={handleShowArchiveModal}>Archive</Dropdown.Item> }
                            { portalUser.userType !== 'portal' && <Dropdown.Item onClick={handleShowAssignModal}>Assign Glucroft User</Dropdown.Item> }
                            { activeFeatures.includes('f_ReassignCaseManager') && <Dropdown.Item onClick={handleShowReassignCaseManagerModal}>Reassign Case Manager</Dropdown.Item> }
                            { portalUser.userType !== 'portal' && <Dropdown.Item onClick={handleShowStatusModal}>Update Status</Dropdown.Item> }
                        </Dropdown.Menu>
                    </Dropdown>

                    {showArchiveModal &&
                        <ArchiveModal
                            showArchiveModal={showArchiveModal}
                            handleCloseArchiveModal={handleCloseArchiveModal}
                            handleArchiveButton={handleArchiveButton}
                        />
                    }

                    {showStatusModal &&
                        <StatusModal
                            showStatusModal={showStatusModal}
                            handleCloseStatusModal={handleCloseStatusModal}
                            handleStatusButton={handleStatusButton}
                            handleStatusChange={handleStatusChange}
                        />
                    }

                    {showAssignModal &&
                        <AssignModal
                            showAssignModal={showAssignModal}
                            handleCloseAssignModal={handleCloseAssignModal}
                            handleAssignButton={handleAssignButton}
                            handleUserChange={handleUserChange}
                            orderIds={selectedRows}
                        />
                    }

                    {showReassignCaseManagerModal &&
                        <ReassignCaseManagerModal
                            showReassignCaseManagerModal={showReassignCaseManagerModal}
                            handleCloseReassignCaseManagerModal={handleCloseReassignCaseManagerModal}
                            handleReassignButton={handleReassignButton}
                            handleReassignChange={handleReassignChange}
                            orderIds={selectedRows}
                            firmNames={selectedFirm}
                        />
                    }
                </div>
            </div>

        <div className='page-table-container' id="table-container-notifications">
            <div className="page-body no-padding">
                <DataTable
                    paginationComponentOptions={paginationComponentOptions}
                    columns={columns}
                    // data={filteredData.slice(0, visibleOrders)}
                    data={filteredData}
                    progressPending={orderStatus === 'loading'}
                    progressComponent={<CustomLoader />}
                    conditionalRowStyles={conditionalRowStyles}
                    selectableRows
                    onSelectedRowsChange={handleSelectedRowsChange}
                    clearSelectedRows={clearRows}
                />
              
            </div>
        </div>
            <div>
                {orderTotal()}
            </div>
    </div>
    );
};

export default OrdersWithNotifications;